module.exports = __webpack_public_path__ + "static/shock-6461310eeb6751d0537b6951dbc15af3.gif";